import React, { useContext } from 'react';
import styles from './Breadcrumb.module.css';
import { BREADCRUMB_LINKS } from '../util/constants';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../contexts/ThemeContext';

const Breadcrumb = ({path}) => {
  const { dark } = useContext(ThemeContext);
  const pathParam = path;

  return (
    <ul className={styles.breadcrumbUl}>
      {pathParam.map((item, i) => {
        let key = item.toLowerCase();
        return (
          <React.Fragment key={i}>
            {pathParam[i + 1] ? (
              <li className={dark ? styles.breadcrumbLiDark : styles.breadcrumbLiLight}>
                <Link to={BREADCRUMB_LINKS[key]}>{item}</Link>
              </li>
            ) : (
              <li className={dark ? styles.breadcrumbLiLastDark : styles.breadcrumbLiLastLight}>
                {item}
              </li>
              )
            }
            {pathParam[i + 1] ? <><span className={styles.breadcrumbSeparator}>/</span></> : ''}
          </React.Fragment>);
      })}
    </ul>
  );
}

export default Breadcrumb;